import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { OrganizationService } from '../_services/generatedServices';

@Injectable()
export class OrgAdminDynamicRedirectGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthenticationService, private org: OrganizationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<UrlTree> {
    const orgId = route.paramMap.get('organizationId');
    const authorizeParam = route.queryParamMap.get('authorize');

    if (authorizeParam) {
      this.auth.loginFromQuerystringToken(authorizeParam);
    }

    return new Promise<UrlTree>((resolve) => {
      if (!this.auth.isLoggedIn()) {
        resolve(this.router.createUrlTree(['/'], { queryParams: { returnUrl: state.url } }));
        return;
      }

      this.org.getOrganization(orgId).subscribe((result) => {
        if (this.auth.isSuperUser() || this.auth.isOrganizationAdmin(result.id)) {
          resolve(this.router.createUrlTree(['/organizations', orgId, 'admin', 'conferences']));
          return;
        }

        // Refresh claims
        this.auth.refreshClaimsAndRefreshUser().then(() => {
          if (this.auth.isOrganizationAdmin(result.id)) {
            resolve(this.router.createUrlTree(['/organizations', orgId, 'admin', 'conferences']));
            return;
          }

          if (this.auth.isOrganizationMember(result.id)) {
            resolve(this.router.createUrlTree(['/organizations', orgId, 'admin', 'learning']));
            return;
          }

          resolve(this.router.createUrlTree(['/'], { queryParams: { returnUrl: state.url } }));
        });
      });
    });
  }
}
